export const mathIcons = {
    Addition: "fa-plus",
    Subtraction: "fa-minus",
    Multiplication: "fa-xmark",
    Division: "fa-divide",
    Power: "fa-superscript",
    Min: "fa-less-than",
    Max: "fa-greater-than",
};
